import { render, staticRenderFns } from "./addRapideMessage.vue?vue&type=template&id=531484ec&scoped=true&"
import script from "./addRapideMessage.vue?vue&type=script&lang=js&"
export * from "./addRapideMessage.vue?vue&type=script&lang=js&"
import style0 from "./addRapideMessage.vue?vue&type=style&index=0&id=531484ec&prod&lang=css&"
import style1 from "./addRapideMessage.vue?vue&type=style&index=1&id=531484ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531484ec",
  null
  
)

export default component.exports